<template>
  <div>
    <cms-programs
      v-if="programsSetUp"
      :theme="programOptions"
      :content="homepage.programs[id]"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'ViewPrograms',
  props: {
    containerIdx: {
      type: Number,
      default: null,
    },
    containerId: {
      type: String,
      default: null,
    },
    componentIdx: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState(['homepage', 'theme', 'isThemePreview']),
    ...mapGetters(['getGlobalThemeSettings']),
    ...mapGetters('translation', ['getComponentTranslation']),
    id() {
      if (this.isThemePreview) {
        return 'preview_id';
      }
      return `${this.containerId}_${this.componentIdx}`;
    },
    programOptions() {
      if (!this.theme?.containers) return {};
      return {
        ...this.theme.containers[this.containerIdx].components[this.componentIdx].options,
        translations: this.getComponentTranslation('programs'),
        globalThemeSettings: this.getGlobalThemeSettings,
      };
    },
    programsSetUp() {
      return !isEmpty(this.homepage?.programs?.[this.id]?.content);
    },
  },
};
</script>
